import { Scanner, Reader, ScannerSymbol, ScannerSymbolType } from './scanner'

export type ShapeName = "star" 
    | "box" 
    | "circle" 
    | "diamond" 
    | "ellipse" 
    | "house" 
    | "oval" 
    | "parallelogram" 
    | "pentagon"
    | "star" 
    | "trapezium" 
    | "triangle" 


export class Shape {
    name : ShapeName
    constructor(name: ShapeName) { this.name = name }
}

export let SHAPES : Shape[] = [
    new Shape("box"),
    new Shape("circle"),
    new Shape("diamond"),
    new Shape("ellipse"),
    new Shape("house"),
    new Shape("oval"),
    new Shape("parallelogram"),
    new Shape("pentagon"),
    new Shape("star"),
    new Shape("trapezium"),
    new Shape("triangle"),
]




class ParserEdge {
    a: string
    b: string

    toString() {
        return `${this.a} -> ${this.b};`
    }
}

export class GraphParser {

    source: String
    edges: ParserEdge[] = []
    shapes = new Map<string,Shape>()

    constructor(source: string) {
        this.source = source ?? ""
    }

    parse() {
        let lines = this.source.split(/\r?\n/)
        for (let i = 0, n = lines.length; i < n; i++) {
            let line = lines[i]
            let scanner = new Scanner(new Reader(line));
            let words : string[] = []
            for (;;) {
                let symbol = scanner.nextSymbol()
                if (symbol.type == ScannerSymbolType.EOS) {
                    break
                } else if (symbol.type == ScannerSymbolType.STRING) {
                    words.push(symbol.value as string)
                } else if (symbol.type == ScannerSymbolType.WORD) {
                    words.push(symbol.value as string)
                }
            }
            if (words.length >= 2) {
                let edge = new ParserEdge()
                let from = this.computeShape(words[0])
                let to = this.computeShape(words[1])
                edge.a = from
                edge.b = to
                this.edges.push(edge)
            }

        }
    }

    computeShape(node: string) {
        if (node?.length <= 1) {
            return node
        }
        if (node?.endsWith("*")) {
            node = node.substring(0, node.length - 1)
            this.shapes.set(node, SHAPES.find(s => s.name == "star"))
        } else if (node?.endsWith("/")) {
            node = node.substring(0, node.length - 1)
            this.shapes.set(node, SHAPES.find(s => s.name == "trapezium"))
        } else if (node?.endsWith("§")) {
            node = node.substring(0, node.length - 1)
            this.shapes.set(node, SHAPES.find(s => s.name == "pentagon"))
        } else if (node?.endsWith("°")) {
            node = node.substring(0, node.length - 1)
            this.shapes.set(node, SHAPES.find(s => s.name == "circle"))
        } else if (node?.endsWith("^")) {
            node = node.substring(0, node.length - 1)
            this.shapes.set(node, SHAPES.find(s => s.name == "triangle"))
        } else if (node?.endsWith("#")) {
            node = node.substring(0, node.length - 1)
            this.shapes.set(node, SHAPES.find(s => s.name == "parallelogram"))
        }
        return node
    }


}